export var loginDefaultValues = {
    Password: '',
    LoginName: undefined,
    LoginPhone: undefined,
    NewPassword: '',
    Token: '',
    CurrentPassword: '',
    RememberLogin: false
};
